import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    SALESORDERS,
    BILLBOARD,
    OPPORTUNITIES,
    COMPANIES,
    CONTACTS,
    KPIS,
    ACTIVITIES,
} from 'constants/Entities';
import { DetailActions } from 'actions';
import Context from 'managers/Context.js';
import { getDetailRoute } from 'utils/fm';

function mapDispatchToProps(dispatch, ownProperties) {
    let { newDetailTab, showDialogEntityDoesNotExist } = bindActionCreators(
        DetailActions,
        dispatch,
    );
    return {
        actions: newDetailTab,
        showErrorDialog: showDialogEntityDoesNotExist,
    };
}

export default (type) => (DecoratedComponent) => {
    let component = class extends Component {
        state = {};

        checkEntityExists = (id, entity, success) => {
            Context.entityManager.getEntityExists(id, entity.entity, (entityExists) => {
                if (entityExists) {
                    success();
                } else {
                    const { showErrorDialog } = this.props;
                    showErrorDialog && showErrorDialog(entity);
                }
            });
        };

        handleTouchTap = (event) => {
            let { actions, id, idEntity, entity, originalOnClick } = this.props;

            event.preventDefault();
            entity = entity ? entity : type;
            // idEntity has priority because the id prop could be the id of the image
            id = idEntity || id;
            switch (entity) {
                case SALESORDERS:
                    actions(entity, id);
                    break;
                case BILLBOARD:
                    actions(entity, id);
                    originalOnClick && originalOnClick();
                    break;
                case KPIS:
                    actions(entity, id);
                    originalOnClick && originalOnClick();
                    break;
                case CONTACTS:
                    this.checkEntityExists(id, entity, () => {
                        window.location.href = getDetailRoute({ entity: CONTACTS, id });
                    });
                    break;
                case OPPORTUNITIES:
                    this.checkEntityExists(id, entity, () => {
                        window.location.href = getDetailRoute({ entity: OPPORTUNITIES, id });
                    });
                    break;
                case COMPANIES:
                    this.checkEntityExists(id, entity, () => {
                        window.location.href = getDetailRoute({ entity: COMPANIES, id });
                    });
                    break;
                case ACTIVITIES:
                    this.checkEntityExists(id, entity, () => {
                        window.location.href = getDetailRoute({ entity: ACTIVITIES, id });
                    });
                    break;
            }
        };

        render() {
            return <DecoratedComponent {...this.props} onClick={this.handleTouchTap} />;
        }
    };

    component.propTypes = {
        new: PropTypes.bool,
    };

    return connect(null, mapDispatchToProps)(component);
};
